import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssInfoPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////



    ////****************** Example 2 ********************************************////
    protected ex2InfoContent: string = "This is info content";
    protected ex2isDismissible: boolean = false;

}
